import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { CartaServices } from '../../../carta/services';
import { CartaCreateSelectTypePage } from '../../../carta/carta-create/carta-create-select-type/carta-create-select-type';

@Component({
  selector: 'page-tutorial-carta',
  templateUrl: 'tutorial-carta.html',
})
export class TutorialCartaPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public cartaServices: CartaServices,) {

  }

  close() {
    /*this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_carta': true,
    }).then(() => {
      this.navCtrl.pop();
    });*/
    this.navCtrl.pop();
  }

  createCarta() {
    if (this.cartaServices.total_cartas >= this.globals.checkLimitsByLicense('menus', 'max_menus') && this.globals.checkLimitsByLicense('menus', 'max_menus') != -1) { //Si limit menus
      this.navCtrl.pop();
    } else {//Si no limit menus
      this.navCtrl.push(CartaCreateSelectTypePage);
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-carta/tutorial-carta.ts